<template>
    <article>
        <h2>
            Winning and Losing
        </h2>

        <p>
            You <strong>win</strong> if you can get <em>1,000 points</em> or more. Since harder questions are worth more points, it's easier to win by getting a strong streak of correct answers at high levels. Otherwise, it could take you quite some time to win.
        </p>

        <p>
            You <strong>lose</strong> if you get <em>3 strikes</em>. Remember, you only get strikes by not answering a question before your time is up. You don't lose any points if you don't answer a question, but it's the fastest way to lose the game.
        </p>

        <p>
            After finishing a game, you can always click the Play Again button to start a new game. See if you can keep up a winning streak or beat your old score!
        </p>
    </article>
</template>
